export default "__VITE_ASSET__AWwQXma1__"